<template>
  <div class="result-checker">
    <div class="result-section">
      <div class="container">
        <div class="section-title">
          <h2>Results</h2>
        </div>
        <div class="settings mb-3">
          <div class="row">
            <label class="col-md-3">Business Name</label>
            <div class="col-md-9">
              <span>{{ LocationName }}</span>
            </div>
          </div>
        </div>
        <div class="settings mb-3">
          <div class="row">
            <label class="col-md-3">Street Address</label>
            <div class="col-md-9">
              <span>{{ LocationAddress }}</span>
            </div>
          </div>
        </div>
        <div class="settings mb-3">
          <div class="row">
            <label class="col-md-3">City</label>
            <div class="col-md-9">
              <span>{{ LocatationCity }}</span>
            </div>
          </div>
        </div>
        <div class="chart-wrap">
          <div class="container">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12">
                <p class="text-start m-0 chart-desc fw-bold">
                  Quality of your location<br />
                  data out of {{ resultsData.length }} directories<br />
                  we checked
                </p>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="chart-data-wrap">
                  <div class="chart-data">
                    <div class="count missing">{{ missing }} %</div>
                    <div class="title">missing</div>
                  </div>
                  <div class="chart-data">
                    <div class="count incorrect">{{ incorrect }} %</div>
                    <div class="title">incorrect</div>
                  </div>
                  <div class="chart-data">
                    <div class="count correct">{{ correct }} %</div>
                    <div class="title">correct</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-5 col-md-3 col-sm-12">
                <Pie
                  :key="jobID"
                  :chart-options="chartOptions"
                  :chart-data="chartData"
                  :chart-id="chartId"
                  :dataset-id-key="datasetIdKey"
                  :plugins="plugins"
                  :css-classes="cssClasses"
                  :styles="styles"
                  :width="width"
                  :height="height"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="result-wrap">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col"></th>
                <th scope="col">Present</th>
                <th scope="col">Correct Name</th>
                <th scope="col">Correct Address</th>
                <th scope="col">Phone</th>
                <th scope="col">Website</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in resultsData" :key="r.Platform" class="list">
                <td>
                  <div class="d-flex align-items-center fw-bold">
                    <div class="image">
                      <img :src="require('@/assets/' + r.Platform + '.png')" />
                    </div>
                    {{ getPublisherName(r.Platform) }}
                  </div>
                </td>
                <td
                  class="present"
                  v-bind:class="{ true: r.Present, false: !r.Present }"
                >
                  <span  v-bind:style="[style_Present(r)]">{{ r.Present }}</span>
                </td>
                <td
                  class="name"
                  v-bind:class="{ true: r.CorrectName, false: !r.CorrectName }"
                >
                  <span v-bind:style="[style_Name(r)]">{{ r.CorrectName }}</span>
                </td>
                <td
                  class="address"
                  v-bind:class="{
                    true: r.CorrectAddress,
                    false: !r.CorrectAddress,
                  }"
                >
                  <span v-bind:style="[style_Address(r)]">{{ r.CorrectAddress }}</span>
                </td>
                <td
                  class="phone"
                  v-bind:class="{ true: r.Phone, false: !r.Phone }"
                >
                  <span v-bind:style="[style_Phone(r)]">{{ r.Phone }}</span>
                </td>
                <td
                  class="website"
                  v-bind:class="{ true: r.Website, false: !r.Website }"
                >
                  <span v-bind:style="[style_Website(r)]">{{ r.Website }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <div class="list list-head">
                        <div></div>
                        <div class="present">Present</div>
                        <div class="name">Correct Name</div>
                        <div class="address">Correct Address</div>
                        <div class="phone">Phone</div>
                        <div class="website">Website</div>
                    </div> -->
          <!-- <div v-for="r in resultsData" :key="r.Platform" class="list">
                        <div class="platform">
                            <div class="image">
                                <img :src="require('@/assets/'+ r.Platform + '.png')" />
                            </div>
                            {{getPublisherName(r.Platform)}}
                        </div>
                        <div class="present" v-bind:class="{'true': r.Present, 'false': !r.Present}"><span :title="showPresent(r)">{{r.Present}}</span></div>
                        <div class="name" v-bind:class="{'true': r.CorrectName, 'false': !r.CorrectName}"><span :title="showName(r)">{{r.CorrectName}}</span></div>
                        <div class="address" v-bind:class="{'true': r.CorrectAddress, 'false': !r.CorrectAddress}"><span :title="showAddress(r)">{{r.CorrectAddress}}</span></div>
                        <div class="phone" v-bind:class="{'true': r.Phone, 'false': !r.Phone}"><span :title="showPhone(r)">{{r.Phone}}</span></div>
                        <div class="website" v-bind:class="{'true': r.Website, 'false': !r.Website}"><span :title="showWebsite(r)">{{r.Website}}</span></div>
                    </div> -->
        </div>
        <div class="btn-download">
          <div class="loader2" v-show="downloadPDF">
    <img :src="require('@/assets/loader.gif')" />  
  </div> 
          
          <button @click="getReport()" v-show="!downloadPDF">Download</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scannerAPI from "../helper/scannerAPI";
import pdfApi from "../helper/pdfAPI";
import { Pie } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

export default {
  name: "Results",
  props: {
    resultsData: {
      type: Array,
      required: true,
    },
    LocationAddress: {
      type: String,
    },
    LocatationCity: {
      type: String,
    },
    LocationName: {
      type: String,
    },
  },
  watch: {
    resultsData(newVal) {
      this.updateGraph(newVal);
    },
  },
  components: { Pie },

  data() {
    return {
      downloadPDF:false,
      jobID: "",
      missing: 0,
      incorrect: 0,
      correct: 0,
      datacalc: [],
      chartOptions: {
        responsive: true,
        plugins: {
            tooltip: {
                callbacks: {
                    label: function(context) {
                        let label = " " + context.dataset.labels[context.dataIndex] || '';

                        if (label) {
                            label += ' : ';
                        }  
                        if (context.formattedValue !== null) {
                            label +=   context.formattedValue  + " %";
                        }
                        return label;
                    }
                }
            }
        }
      },
      locationCity: [], 
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    // getCity() {
    //   this.locationCity = this.LocationAddress.split(',');
    //   return this.locationCity[1];
    // },
    chartData() {
      this.updateGraph(this.resultsData);
      return {
        datasets: [
          {
            labels: [ 'Missing', 'Incorrect', 'Correct' ],
            data: this.datacalc,
            backgroundColor: ["#D4145A", "#FFCF00", "#39B54A"],
          },
        ],
      };
    },
  },
  mounted() {
    this.updateGraph(this.resultsData);
  },
  methods: {
    style_Present(row){
      if(this.showPresent(row) === '') {
        return "--my-color-var:none";
      }
      return "--my-color-var:'"+this.showPresent(row) + "'"
    },
    style_Name(row){
      if(this.showName(row) === '') {
        return "--my-color-var:none";
      }
      return "--my-color-var:'"+this.showName(row) + "'"
    },
    style_Phone(row){
      if(this.showPhone(row) === '') {
        return "--my-color-var:none";
      }
      return "--my-color-var:'"+this.showPhone(row) + "'"
    },
    style_Website(row){
      if(this.showWebsite(row) === '') {
        return "--my-color-var:none";
      }
      return "--my-color-var:'"+this.showWebsite(row) + "'"
    },
    style_Address(row){
      if(this.showAddress(row) === '') {
        return "--my-color-var:none";
      }
      return "--my-color-var:'"+this.showAddress(row) + "'"
    },
    showPresent(row) {
      if (!row.Present) {
        return "Not found on platform";
      }
      return "";
    },
    showName(row) {
      if (!row.CorrectName && row.Present) {
        return row.NameFound;
      }
      return "Not found on platform";
    },
    showPhone(row) {
      if (!row.Phone && row.Present) {
        return "Not found";
      }
      return "Not found on platform";
    },
    showWebsite(row) {
      if (!row.Website && row.Present) {
        return "Not found";
      }
      return "Not found on platform";
    },
    showAddress(Row) {
      if (Row.CorrectAddress === false && Row.Present) {
        return Row.AddressFound;
      }
      return "Not found on platform";
    },
    updateGraph(NewData) {
      let numMissing = 0;
      let numIncorrect = 0;
      let numCorrect = 0;

      //console.log("updateGraph");
      for (let index = 0; index < NewData.length; index++) {
        const element = NewData[index];
        if (!element.Present) {
          numMissing++;
        } else {
          // if(!element.Address || !element.Phone ||!element.Website){
          //   numMissing++;
          // }else{
          if (element.CorrectAddress) {
            numCorrect++;
          } else {
            numIncorrect++;
          }
          //}
        }
      }
      //console.log("updateGraph", numMissing, numIncorrect, numCorrect);
      this.missing = ((numMissing / NewData.length) * 100).toFixed(0);
      this.incorrect = ((numIncorrect / NewData.length) * 100).toFixed(0);
      this.correct = ((numCorrect / NewData.length) * 100).toFixed(0);
      this.datacalc = [this.missing, this.incorrect, this.correct];
      this.jobID = new Date().getTime().toString();
    },
    getPublisherName(Publisher) {
      return scannerAPI.getPublisher()[Publisher.toLowerCase()];
    },
    handleScroll() {
      let header = document.getElementById("headerSection");
      let sticky = header.offsetTop;
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    },
    getReport(){
      this.downloadPDF = true;
      let reportDataPdf = { "search": {
                                "locationName": this.LocationName,
                                "Address": this.LocationAddress,
                                "City": this.LocatationCity
                            },"report": JSON.parse(JSON.stringify(this.resultsData))};

      pdfApi.getReport("sW7H52Sma2",reportDataPdf).then(d=>{
        var file = new Blob([d], { type: 'application/pdf' });
          this.downloadPDF = false;
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
      });
    }
  },
};
</script>
